export const ON_CONFIRM_DIALOG_OPEN = 'ON_CONFIRM_DIALOG_CONFIRM';
export const ON_CONFIRM_DIALOG_HIDE = 'ON_CONFIRM_DIALOG_HIDE';
export const ON_SOCKET_LOT_UPDATED = 'ON_SOCKET_LOT_UPDATED';
export const TOGGLE_LOT_WATCHLIST_STATE = 'TOGGLE_LOT_WATCHLIST_STATE';
